/**
 * Enum of metadata `id` values assigned to schemas in this library.
 *
 * Extends @dfinity/zod-schemas/ZodSchemaId
 */
export enum JunoSchemaId {
  /** Metadata id for {@link NatSchema}. */
  Nat = 'Nat'
}
